/**
 * The curated demo insights hooked into real data and backend processing (live mode).
 * In demo mode this filter is lifted and the full catalogue of insights renders as
 * static cards instead.
 */
export const LIVE_CARD_IDS = [
    "ins_demo_high_food_cost",
    "ins_demo_menu_mix_labor",
    "ins_demo_store_health",
    "ins_demo_promotion_effectiveness",
    "ins_demo_loyalty_churn"
];
